module.exports = __webpack_public_path__ + "static/media/logo-culiacan.de151a96.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/places/logo-culiacan.png
// module id = 1094
// module chunks = 0